/* NY2K Luxe - reveals and the index/detail switcher for the bridal pages.
   Content is visible without this script; it only adds motion and the switcher. */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    if(!root||root.dataset.lxReady)return;root.dataset.lxReady='1';
    root.classList.remove('lx-no-js');
    var items=root.querySelectorAll('[data-rv],[data-hero]');
    if('IntersectionObserver' in window&&!reduce){
      root.classList.add('lx-js');
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
      items.forEach(function(el){io.observe(el);});
      setTimeout(function(){items.forEach(function(el){el.classList.add('in');});},4500);
    }else{items.forEach(function(el){el.classList.add('in');});}
    root.querySelectorAll('[data-index]').forEach(function(ix){
      var btns=[].slice.call(ix.querySelectorAll('[data-go]')),cards=[].slice.call(ix.querySelectorAll('[data-card]'));
      function show(i){btns.forEach(function(b,k){b.setAttribute('aria-selected',k===i?'true':'false');b.tabIndex=k===i?0:-1;});cards.forEach(function(c,k){c.classList.toggle('on',k===i);c.hidden=k!==i;});}
      btns.forEach(function(b,i){
        b.addEventListener('click',function(){show(i);});
        if(matchMedia('(hover:hover) and (pointer:fine)').matches)b.addEventListener('mouseenter',function(){show(i);});
        b.addEventListener('keydown',function(e){var n=null;if(e.key==='ArrowDown'||e.key==='ArrowRight')n=(i+1)%btns.length;if(e.key==='ArrowUp'||e.key==='ArrowLeft')n=(i-1+btns.length)%btns.length;if(n!==null){e.preventDefault();show(n);btns[n].focus();}});
      });
      show(0);
    });
  }
  function all(){document.querySelectorAll('[data-lx]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('[data-lx]');if(r){delete r.dataset.lxReady;init(r);}});
})();
